import { Injectable, Type } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalComponent } from "../modal.component";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  private modalRef?: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  openModal<T>(
    component: Type<T>,
    title: string = "Modal",
    widthClass: string = "",
    data?: any
  ) {
    if (this.modalRef) {
      this.modalRef.close();
    }

    this.modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      modalDialogClass: widthClass,
    });

    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.component = component;
    this.modalRef.componentInstance.widthClass = widthClass;
    this.modalRef.componentInstance.data = data;
  }

  closeModal() {
    this.modalRef?.close();
  }
}
